import CreatorCourseManagementScreen from '@/features/unified-learning/creator/screens/CreatorCourseManagementScreen';

export default CreatorCourseManagementScreen;
